export const urls = {
  allConversations: {
    method: "POST",
    url: "/conversation"
  },
  checkPhoneNumber: {
    method: "GET",
    url: "/phone-number"
  },
  identicalConversations: {
    method: "POST",
    url: "/conversation/by-participant-numbers"
  }
};
